import { useDisclosure } from "@mantine/hooks";

import { useAnalytics } from "@/analytics";

export function useStatsDrawer() {
    const [opened, { open, close }] = useDisclosure(false);
    const { dispatcher } = useAnalytics();

    const handleClose = (source: string) => {
        void dispatcher.dispatchBusinessEvent("CloseExpertPerformanceDashboard", { source });
        close();
    };

    const handleOpen = (source: string) => {
        void dispatcher.dispatchBusinessEvent("OpenExpertPerformanceDashboard", { source });
        open();
    };

    const toggle = (source: string, canOpen: boolean) => {
        if (opened) {
            handleClose(source);
        } else if (canOpen) {
            handleOpen(source);
        }
    };

    return {
        opened,
        handleOpen,
        handleClose,
        toggle,
    };
}
